import { useEffect, useMemo, useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Accordion, Col, Container,  Form, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import SplashPage from '../SplashPage';
import { BsFillBuildingsFill } from 'react-icons/bs';
import { useAuthState } from "../../context/AuthContext";
import { useQuery, useQueryClient } from "react-query";
import { FaCheck, FaPlus } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import AreYouSureModal from "../../components/shared/AreYouSureModal";
import BuildingsMap from "../../components/hw/BuildingsMap";
import ChangeHwModal from "../../components/buildings/ChangeHwModal";
import BuildingAccordionItem from "../../components/buildings/BuildingAccordionItem";

/**
 * BUildingsPage
 * 
 * In this page will be shown all building logged user has in his management
 * 
 * @returns None
 */
const BuildingsPage = () => {

    const API = new PrivateApi(); // Class for API calls
    const { contactPerson } = useAuthState(); // logged user to compare with buildings
    const queryClient = useQueryClient();

    const { data, dataUpdatedAt, error, isLoading } = useQuery("GET_BUILDINGS_QUERY", API.hw_Buildings);


    const { data: anlagenData, error: anlagenError, isLoading: anlagenLoading } = useQuery("GET_ALL_ANLAGEN", API.get_Anlagen_all, { staleTime: Infinity }
    );

    const buildings = useMemo(() => {
        if (!data?.data?.buildings) return [];
        return [...data.data.buildings].sort((a, b) => a.id - b.id);
    }, [dataUpdatedAt]);
    const tickets = data?.data?.tickets ?? [];

    const [onlyObjektbezichnung, setOnlyObjektbezeichnung] = useState(false) // filter only objektbezeichnung
    const [searchField, setSearchField] = useState(""); // Search field
    const [isSearchFieldFocus, setIsSearchFieldFocus] = useState(false);
    const filteredBuildings = useMemo(() => {
        if (!searchField) return buildings;

        const search = searchField.toLowerCase();

        return buildings.filter(b => {
            if (onlyObjektbezichnung) {
                return b.x_objektbezeichnung?.toLowerCase().includes(search);
            }

            return (
                b.name?.toLowerCase().includes(search) ||
                b.zip?.toLowerCase().includes(search) ||
                b.street?.toLowerCase().includes(search) ||
                b.city?.toLowerCase().includes(search) ||
                b.x_objektbezeichnung?.toLowerCase().includes(search)
            );
    });
}, [buildings, searchField, onlyObjektbezichnung]);
    

    const [cancelModal, setCanceModal] = useState(false); // are you sure dialog modal
    const [cancelTicketId, setCancelTicketId] = useState(0); // ticket id for ticket which was abbrechen btn was clicked
    const [cancelLoading, setCancelLoading] = useState(false);
    const [mapClicked, setMapClicked] = useState(false); // map clicked state

    const [hwChangeModal, setHWChangeModal] = useState(false);
    const [hwChangeBuilding, setHwChangeBuilding] = useState(null);

    const [hwChangeCancelTicketId, setHwChangeCancelTicketId] = useState(0);
    const [hwChangeCancelModal, setHwChangeCancelModal] = useState(false);
    const [hwChangeCancelLoading, setHwChangeCancelLoading] = useState(false);
    const hwChangeCancelTitle = "HV-Wechsel abbrechen";
    const hwChangeCancelMsg = "Sind Sie sicher, dass Sie den HV-Wechsel abbrechen wollen?";

    // Deprecated for time beeing
    /* const goToAnlageDetails = (e, building_id, name) => {
        e.preventDefault();
        navigate(`/hw/dashboard/gebaeude/anlagen/${building_id}`, {state: {building: name}});
    } */

    const showCancelModal = (ticket_id) => {
        setCancelTicketId(ticket_id);
        setCanceModal(true);
    }

    
    // close ticket and new building
    const closeTicket = () => {
        var ticketData = {ticket_id: cancelTicketId, user: contactPerson.name}
        setCancelLoading(true);
        API.post_Ticket_close(ticketData)
            .then(() => {
                queryClient.invalidateQueries("GET_BUILDINGS_QUERY");
                
                setCancelLoading(false);
                setCanceModal(false);
            });
    }


    const hwChangeModalHandler = (building) => {
        setHwChangeBuilding(building);
        setHWChangeModal(true);
    }


    // creates items for new building from ticket
    const createNewBuildingItems = (ticket) => {
        var building_info = {};
        var anlagen_info = [];

        if (ticket.description.includes('<tbody>')) {
            var tables = ticket.description.split('<tbody>');
            if (tables.length > 0) {
                var building_rows = tables[1].split('<tr>').filter(Boolean);

                building_rows.forEach(row => {
                    var matches = row.match(/<td>(.*?)<\/td>/g);
                    if (matches && matches.length >= 2) {
                        var key = matches[0].replace(/<td>|<\/td>/g, '').trim();
                        var value = matches[1].replace(/<td>|<\/td>/g, '').trim();

                        if (key === 'Gebäudename') building_info['name'] = value;
                        if (key === 'Objektbezeichnung') building_info['x_objektbezeichnung'] = value;
                        if (key === 'Vorgang') building_info['vorgang'] = value;
                        if (key === 'Straße') building_info['street'] = value;
                        if (key === 'Hausnummer') building_info['housenumber'] = value;
                        if (key === 'PLZ') building_info['zip'] = value;
                        if (key === 'Ort') building_info['city'] = value;
                        if (key === 'Kontaktperson') building_info['contact'] = value;
                    }
                });

                if (tables.length > 1) {
                    var new_anl = {};
                    for (let i = 1; i < tables.length; i++) {
                        var rows = tables[i].split('<tr>').filter(Boolean);
                        
                        rows.forEach(row => {
                            if (row.includes('end anlage')) {
                                anlagen_info.push(new_anl);
                                new_anl = {};
                            }
                            var matches = row.match(/<td>(.*?)<\/td>/g);
                            if (matches && matches.length >= 2) {
                                var key = matches[0].replace(/<td>|<\/td>/g, '').trim();
                                var value = matches[1].replace(/<td>|<\/td>/g, '').trim();

                                if (key === 'Anlagenverwendung') new_anl['x_anlagenverwendung'] = value;
                                if (key === 'Spezifische Anlagenverwendung') new_anl['x_anlagenverwendung_detail'] = value;
                                if (key === 'Top') new_anl['top'] = value;
                                if (key === 'Bestandeinheitennummer') new_anl['x_bestandheitsnummer'] = value;
                                if (key === 'Energieform') new_anl['x_energieform'] = value;
                                if (key === 'Zählernummer') new_anl['x_zaehlernummer_1'] = value;
                                if (key === 'Zweite Zählernummer') new_anl['x_zaehlernummer_2'] = value;
                                if (key === 'Anlage anmelden am') new_anl['register_from'] = value;
                                if (key === 'Als Leerstand anmelden') new_anl['leerstand'] = value;

                            }

                        });
                    }
                }

                return (
                    <Accordion.Item id={`ticket-${ticket.id}`} key={`ticket-${ticket.id}`} eventKey={`ticket-evt-${ticket.id}`} style={{marginBottom: "10px", border: "1px dashed #ced4da"}}>
                        <Accordion.Header style={{opacity: 0.5}}>
                            <Row style={{ width: "100%" }} className="align-items-center">
                                <Col xs="12" md="2" xl="1">
                                    <BsFillBuildingsFill size={70} />
                                </Col>
                                <Col xs="12" md="10" xl="11">
                                    {building_info.name} <br />
                                    <small>{building_info.street}, {building_info.zip} {building_info.city}</small> <br />
                                    {building_info.x_objektbezeichnung !== "False" ?
                                        <small><span className="text-muted">Objektbezeichnung: </span>{building_info.x_objektbezeichnung}</small>
                                        : null}
                                </Col>
                            </Row>
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row style={{opacity: 0.5}}>
                                <Col xs="12" xl="4">
                                    <small className="text-muted">Straße</small>
                                    <p>{building_info.street}</p>
                                </Col>
                                <Col xs="12" xl="4">
                                    <small className="text-muted">PLZ</small>
                                    <p>{building_info.zip}</p>
                                </Col>
                                <Col xs="12" xl="4">
                                    <small className="text-muted">Ort</small>
                                    <p>{building_info.city}</p>
                                </Col>
                            </Row>
                            <hr />
                            <ListGroup variant="flush" className="text-start" style={{opacity: 0.5}}>
                                {anlagen_info.length > 0 ?
                                    anlagen_info.map(anlage =>
                                        <ListGroupItem>
                                            <Row className="text-center">
                                                <Col xs="12" md="4" xl="4" className="border-right">
                                                    <p className="text-muted"><small>Anlage anmelden</small></p>
                                                    {anlage.register_from !== undefined ?
                                                        <>
                                                            <FaCheck className="text-energo" /> &nbsp;
                                                            am {new Date(anlage.register_from).toLocaleDateString('DE-de')}
                                                        </>
                                                        :
                                                        <FaXmark className="text-danger" />
                                                    }
                                                </Col>
                                                <Col xs="12" md="4" xl="4" className="border-right">
                                                    <p className="text-muted"><small>Energieform</small></p>
                                                    <p>{anlage.x_energieform}</p>
                                                </Col>
                                                <Col xs="12" md="4" xl="4">
                                                    <p className="text-muted">Anlagenverwendung</p>
                                                    {
                                                        anlage.x_anlagenverwendung === 'Allgemeine Liegenschaftsteile'?
                                                            anlage.x_anlagenverwendung_detail :
                                                            `Top ${anlage.top}`
                                                    }
                                                </Col>
                                            </Row>
                                        </ListGroupItem>
                                    )

                                    : null
                                }
                            </ListGroup>
                            <hr />
                            <Row className="text-center accordion-footer">
                                <Col xs="12" md="4" xl="4">
                                    <a onClick={e => {e.preventDefault(); showCancelModal(ticket.id)}} href={`/gebaeude/abbrechen/${ticket.id}`} className="link-energo text-danger">Hinzufügen abbrechen</a>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                )
            }
        }
    }


    const hwChangeCancelHandler = () => {
        setHwChangeCancelLoading(true);
        var ticketData = {ticket_id: hwChangeCancelTicketId, contactPerson: ""};
        API.post_Ticket_close(ticketData)
            .finally(() => {
                queryClient.invalidateQueries(["GET_BUILDINGS_QUERY"]);
                setHwChangeCancelModal(false);
                setHwChangeCancelLoading(false);
            });
    }


    // if loading
    if (isLoading || anlagenLoading) return <SplashPage />

    // if error 
    if (error || anlagenError) return <p>Es ist ein Fehler aufgetreten. Versuche es später erneut.</p>


    // GUI
    return (
        <>
            {buildings.some(b => b.partner_longitude > 0 && b.partner_latitude > 0) &&
                <BuildingsMap mapClicked={mapClicked} setMapClicked={setMapClicked} buildings={buildings.filter(b => b.partner_latitude > 0 && b.partner_longitude > 0)} />
            }
            <Container className="text-start" onClick={() => setMapClicked(false)} style={{marginTop: -23, paddingTop: 50,  marginBottom: 50 }}>
                <Row>
                    <Col xs="12" xl={isSearchFieldFocus ? "4" : "8"}>
                        <h3>Alle verwalteten Gebäude</h3>
                        <a href="neu/" className="btn btn-energo" style={{borderRadius: 18}}><FaPlus style={{marginTop: -2, marginRight: 2}} /> Neue WEG/MEG</a>
                    </Col>
                    <Col xs="12" xl={isSearchFieldFocus ? "8" : "4"}>
                        <Form.Control
                            onFocus={() => setIsSearchFieldFocus(true)}
                            onBlur={() => setIsSearchFieldFocus(false)}
                            className="rounded-pill"
                            value={searchField}
                            onChange={e => setSearchField(e.target.value)}
                            type="search"
                            placeholder="Suche nach Objektbezeichnung, Straße, Gebäudename, PLZ, Ort, ..."
                        />
                        <Form.Check
                            style={{ marginLeft: "5px", marginTop: "10px" }}
                            type="switch"
                            label="Nur Objektbezeichnung filtern"
                            onChange={e => setOnlyObjektbezeichnung(e.target.checked)}
                        />
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col xs="12" xl="6">
                    </Col>
                </Row>


                <Accordion className="mt-5">
                    {filteredBuildings.length > 0 ?
                        filteredBuildings.map((building) => (
                            <BuildingAccordionItem 
                                key={`accordion-${building.id}`}
                                building={building} 
                                anlagen={anlagenData.filter(a => a.x_studio_field_Xhbek[0] === building.id || a.x_gebaeude_id[0] === building.id)}
                                tickets={tickets.filter(t => t.partner_id[0] === building.id)}
                                hwChangeHandler={hwChangeModalHandler}
                                cancelTicketId={setHwChangeCancelTicketId}
                                cancelModal={setHwChangeCancelModal}
                            />
                        ))
                        : <p>Keine Gebäude gefunden...</p>
                    }
                </Accordion>

                {tickets && tickets.filter(t => t.ticket_type_id === 18).length > 0 &&
                    <Accordion className="mt-5">
                        <p id="newBuildingsPId"><b>Neue Liegenschaft (warten auf Freigabe durch ENERGO)</b></p>
                        {tickets
                            .filter(t => t.ticket_type_id[0] === 18)
                            .map(ticket => createNewBuildingItems(ticket))
                        }
                    </Accordion>
                }

                <AreYouSureModal 
                    show={cancelModal} 
                    setShow={setCanceModal} 
                    title="Hinzufügen abbrechen" 
                    message="Wollen Sie das Hinzufügen der Liegenschaft wirklich abbrechen?"
                    yesHandler={closeTicket}
                    loading={cancelLoading}
                />
                <AreYouSureModal
                    show={hwChangeCancelModal}
                    setShow={setHwChangeCancelModal}
                    title={hwChangeCancelTitle}
                    message={hwChangeCancelMsg}
                    yesHandler={hwChangeCancelHandler}
                    loading={hwChangeCancelLoading}
                />

                <ChangeHwModal show={hwChangeModal} setShow={setHWChangeModal} building={hwChangeBuilding}/>
            </Container>
        </>
    )
}

export default BuildingsPage;